import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import { Field, reduxForm } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import { InputField, password, matchField } from '../components/form';
import { Blank as Layout } from '../components/layouts';
import { SessionApi } from '../api';
import { setLoader, removeLoader } from '../actions';

class ResetPassword extends Component {

  componentWillMount() {
    const { isAuthenticated, dispatch, redirectTo } = this.props;
    if (isAuthenticated) dispatch(push(redirectTo));
  }

  onFormSubmit(values) {
    const { dispatch, isPublisher, isAdvertiser, routeParams: { resetPasswordToken } } = this.props;
    dispatch(setLoader('passwordResetForm'));
    const platform = isPublisher ? 'Publisher' : (isAdvertiser ? 'Advertiser' : '');
    values.user.reset_password_token = this.props.routeParams["token"];
    dispatch(SessionApi.actions.resetPassword.put({ ...values, platform }, (error, success) => {
      dispatch(removeLoader('passwordResetForm'));
      if (success) {
        dispatch(push(`/${platform}/login`));
      }
    }));
  }

  render() {
    const { handleSubmit, isPublisher } = this.props;
    const platform = isPublisher ? 'publisher' : 'advertiser';
    return (
      <Layout>
        <div className='middle-box text-center loginscreen animated fadeIn'>
            <div>
                <div>
                    <h1 className='logo-name'>JobAdX</h1>
                </div>

                <h3 style={{ textTransform: 'capitalize' }}>
                  {platform} platform
                </h3>

                <p>Choose a new password</p>

                <form
                  onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
                  className='m-t text-right'
                >

                  <Field
                    type='password'
                    name='user[password]'
                    placeholder='Password'
                    component={InputField}
                    validate={[password]}
                  />

                  <Field
                    type='password'
                    name='user[password_confirmation]'
                    placeholder='Confirm Password'
                    component={InputField}
                    validate={[matchField('password', 'user'), password]}
                  />

                  <Button
                    type='submit'
                    loading={this.props.isLoading}
                    bsStyle='primary'
                    className='block full-width m-b'
                  > Reset Password
                  </Button>

                  <div className='text-center'>
                    <Link to={`/${platform}/forgotpassword`}>
                      <small>
                        Go back
                        </small>
                    </Link>
                  </div>
                </form>
            </div>
        </div>
      </Layout>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'passwordResetForm'
});

const mapStateToProps = (state, ownProps) => {
  const { location: { pathname } } = ownProps;
  const { loader, auth: { data: { isAuthenticated } } } = state;
  const isLoading = loader.includes('passwordResetForm');

  return {
    initialValues: { user: { password: '', password_confirmation: '' } },
    isAuthenticated,
    isLoading,
    redirectTo: '/initializing',
    isPublisher: pathname.match(/publisher/i),
    isAdvertiser: pathname.match(/advertiser/i)
  };
};

export default connect(mapStateToProps)(ResourceForm(ResetPassword));
